<script setup lang="ts">
import { useEventQuery } from "~/queries/catalog/events";

const props = defineProps<{ eventId: string }>();
const eventIdentifier = computed(() => props.eventId);

const localePath = useLocalePath();
const { data: event } = useEventQuery(eventIdentifier);
</script>

<template>
  <ProductDescriptionDrawerBase
    v-if="event"
    :title="$t('product.description.eventDrawerTitle')"
  >
    <template #content>
      <NuxtLink
        :to="localePath(getEventRoute(event))"
        aria-label="Link to event page"
        class="border rounded-sm p-4 md:p-5 interaction-white uppercase"
      >
        <SearchResultPageEventCard :event="event" />
      </NuxtLink>
    </template>
  </ProductDescriptionDrawerBase>
</template>
